import KBaseMapMarker from "@/components/Maps/KBaseMapMarker";
import KScheduleInfoWindow from "../info-windows/KScheduleInfoWindow";
import ScheduleIcon from "../mixins/schedule-icon";
import { zIndexMap } from "@/data/map-markers";

export default {
	name: "KScheduleMarker",

	props: {
		isChildMarker: Boolean,
		schedule: Object
	},

	mixins: [ ScheduleIcon ],

	computed: {
		title() {
			if ( this.schedule.customer ) {
				return `${this.schedule.scheduleTypeNames} for ${this.schedule.customer.name}`;
			}

			return this.schedule.scheduleTypeNames;
		},

		zIndex() {
			const scheduleType = this.schedule.scheduleTypeNames.toLowerCase();

			if ( scheduleType.indexOf( "delivery" ) !== -1 ) {
				return zIndexMap.scheduleDelivery;
			} else if ( scheduleType.indexOf( "pickup" ) !== -1 ) {
				return zIndexMap.schedulePickup;
			} else if ( scheduleType.indexOf( "return" ) !== -1 ) {
				return zIndexMap.scheduleReturn;
			}
		}
	},

	render() {
		return <KBaseMapMarker
			autoPan
			icon={this.markerIcon}
			isChildMarker={this.isChildMarker}
			lat={this.schedule.address.lat}
			lng={this.schedule.address.lng}
			markerId={this.schedule.id}
			markerType="schedule"
			title={this.title}
			zIndex={this.zIndex}
			scopedSlots={{
				active: () => <KScheduleInfoWindow
					schedule={this.schedule}
				></KScheduleInfoWindow>
			}}
		></KBaseMapMarker>;
	}
};
